<div class="container">
  <div class="row">
    <div *ngIf="isLoading" class="col-12 pt-5 text-center">
      <mat-spinner class="m-0 m-auto"></mat-spinner>
    </div>
    <div class="col-md-12" *ngIf="!isLoading">
      <h1>Creditor Import</h1>
      <div class="card">
        <div class="card-body">
          <!-- Server Errors -->
          <div class="m-4" *ngIf="serverResponse">
            <app-server-response [title]="serverResponse.message" [errors]="serverResponse.errors">
            </app-server-response>
          </div>
          <form [formGroup]="form" (ngSubmit)="submitForm()">
            <div class="row">
              <div class="col-12">
                <div class="mt-3">
                  <p>Import File column headings:</p>
                  <code>Reference | Creditor name | New Creditor name | Confirmed debt | Negotiated Amount | Product
                    type | Creditor Status</code>
                  <br/>
                  <small>The names are important, they can not differ from the above.</small><br/>
                  <small>The file must be a .csv and it must be comma-separated.</small>
                </div>
              </div>
              <div class="col-6 mt-4">
                <div class="form-group">
                  <label for="files">{{ "CONFIG.sms-template.attachments.placeholder" | translate }}</label>
                  <div class="input-group">
                    <div class="custom-file">
                      <input class="custom-file-input" id="uploadFile" type="file" name="file" accept=".csv"
                             (change)="onAttachmentsChange($event)"/>
                      <label class="custom-file-label" for="uploadFile" id="uploadLabel">
                        {{ 'CONFIG.sms-template.attachments.placeholder' | translate }}
                      </label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-start align-items-center"
                       *ngFor="let file of pickedFiles; let i=index">
                    <span matSuffix>
                    {{ file.name + '.' + file.extension + ' ' }}
                      <small>{{ file.size / 1048576 | number:'1.2-2' }} MB</small>
                    </span>
                    <button mat-icon-button color="warn" (click)="removeLocalAttachment(i)">
                      <mat-icon class="text-danger mat-icon">remove_circle</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <app-spinner-btn type="submit" [loading]="isSubmitting" class="float-right mt-3"
                             [name]="'SHARED.submit' | translate">
            </app-spinner-btn>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
